import React, {  useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../../../SpaAndWellCommonStyles.module.scss';
import metadata from './TanningSalon.metadata.json5';
import TanningEquipment from '../TanningEquipment/TanningEquipment';

function TanningSalon(props) {

const { submissionVM, updateWizardData,pathUpdated} = props;
const breakpoint = useContext(BreakpointTrackerContext);
const { onValidate } = useValidation('TanningSalon');
const modelVM = _.get(submissionVM, pathUpdated);

modelVM.value.isValidationReq = true;


// eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        tanningEquComponent: {
            data: modelVM.tanningEquExposures,
            updateWizardData,
            submissionVM,
            tanningEquipPath: `${pathUpdated}.tanningEquExposures`,
            pathUpdated
        },
        isthetansallisasafCanFie: {
            visible: !_.isUndefined(modelVM.value.aretheTanStaSmaTanCerFie)
                && modelVM.value.aretheTanStaSmaTanCerFie === true
        },
        submitCertification: {
            visible: !_.isUndefined(modelVM.value.isthetansallisasafCanFie)
                && modelVM.value.isthetansallisasafCanFie === true
        },
        plecheYESsothawecaCanFie: {
            visible: !_.isUndefined(modelVM.value.isthetansallisasafCanFie)
                && modelVM.value.isthetansallisasafCanFie === true
        }
    };


const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            tanningEquComponent: TanningEquipment
        },
        resolveClassNameMap: styles
    };

const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM,pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM,`${fullPath}`,value);

            updateWizardData(submissionVM);         
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

return (
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={modelVM}
                resolveValue={readValue}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                onValueChange={handleValueChange}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
    );


}

TanningSalon.propTypes = wizardProps;
export default withRouter(TanningSalon);
